"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProviderType = void 0;
var AuthProviderType;
(function (AuthProviderType) {
    AuthProviderType["LOCAL"] = "local";
    AuthProviderType["FACEBOOK"] = "facebook";
    AuthProviderType["GOOGLE"] = "google";
    AuthProviderType["GITHUB"] = "github";
    AuthProviderType["AZURE"] = "azure";
})(AuthProviderType = exports.AuthProviderType || (exports.AuthProviderType = {}));
//# sourceMappingURL=authProviderType.js.map